// app/src/parentShim.local.js
// shim for the JS code that is in the Shopify page template that handles navigation
if (window.self === window.top && window.location.hostname === 'localhost') {
  window.addEventListener('message', (event) => {
    const data = event.data || {};
    if (data.action === 'redirect') {
      const url = data?.data?.url || '/';
      const search = data?.data?.search ? `?${data.data.search}` : '';
      // Local: just navigate within the SPA
      const target = `${url}${search}`;
      if (window.history && window.history.pushState) {
        window.history.pushState({}, '', target);
        window.dispatchEvent(new PopStateEvent('popstate')); // notify React Router
      } else {
        window.location.assign(target);
      }
    }
  });
}
